// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2weWc","head":"ProcedureTableInfo_head__1YEvX"};